var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tsyqq3ylka",
    d: "M21.98.129C9.84.129 0 10.249 0 22.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574C43.96 10.248 34.12.129 21.98.129z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589 -709) translate(95 157) translate(406 552) translate(88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6pf4l543mb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tsyqq3ylka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#25E47A",
    d: "M21.98 2.129C9.84 2.129 0 12.249 0 24.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574 0-12.483-9.84-22.602-21.98-22.602z",
    mask: "url(#6pf4l543mb)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.124 24.024h-.005c-2.153-.001-4.265-.58-6.108-1.673l-.438-.26-4.542 1.191 1.213-4.428-.286-.454C.757 16.49.123 14.281.124 12.014c.002-6.616 5.386-12 12.005-12 3.205.002 6.218 1.252 8.483 3.52 2.266 2.268 3.513 5.283 3.512 8.49-.003 6.616-5.386 12-12 12zm6.582-8.988c-.36-.18-2.134-1.053-2.465-1.173-.33-.12-.571-.18-.812.18-.24.361-.931 1.174-1.142 1.415-.21.24-.42.27-.781.09-.361-.18-1.524-.562-2.902-1.79-1.072-.957-1.796-2.139-2.006-2.5-.21-.361-.002-.537.158-.736.39-.485.781-.993.902-1.234.12-.24.06-.451-.03-.632-.09-.18-.812-1.956-1.113-2.678-.293-.704-.59-.609-.811-.62-.21-.01-.451-.012-.692-.012-.24 0-.631.09-.962.451-.33.361-1.262 1.234-1.262 3.01 0 1.775 1.292 3.49 1.473 3.731.18.241 2.544 3.885 6.162 5.447.86.372 1.533.594 2.057.76.864.275 1.65.236 2.272.143.693-.103 2.134-.872 2.435-1.715.3-.843.3-1.565.21-1.715-.09-.15-.33-.241-.691-.422z",
    transform: "translate(-589 -709) translate(95 157) translate(406 552) translate(88) translate(10 12)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1ef2466815ee57b423219741f0bed45b.svg";
export { ForwardRef as ReactComponent };